export default __webpack_public_path__ + "dbac67235a3359e441d780800fd17148.svg";